import z from "zod";
import { FirestoreDateSchema } from "./UserServiceTypes";

export const AppNotificationSchema = z.object({
  created_at: FirestoreDateSchema,
  show_after: FirestoreDateSchema,
  show_version: z.string(),
  title: z.string(),
  message: z.string(),
  type: z.enum(["info"]),
});
export type AppNotification = z.infer<typeof AppNotificationSchema>;
